import React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { pages } from '../routes';

interface Props {
  isDesktop: boolean;
  handleDrawerToggle: () => void;
}

const NavigationDrawer: React.FC<Props> = ({ isDesktop, handleDrawerToggle }) => {
  const location = useLocation();
  return (
    <Box onClick={!isDesktop ? handleDrawerToggle : undefined}>
      <List>
        {pages.map(({ name, path, icon }) => (
          <ListItem key={name} disablePadding>
            <ListItemButton
              component={Link}
              to={path}
              selected={location.pathname === path}
              sx={{
                '&.Mui-selected': { backgroundColor: 'rgb(239,253,219)' },
                '&:hover': { backgroundColor: 'rgb(249,255,244)' },
              }}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default NavigationDrawer;
